<template>
  <div>
    <div :class="$style.price">
      <span :class="$style.strikethrough + ' text-muted'" v-if="tier != 'basic'">
        {{ prices[tier][currency]['symbol'] }}{{ prices[tier][currency][term].toFixed(0) }}
      </span>
      <span v-if="tier != 'basic'">
        {{ prices[tier][currency]['symbol'] }}{{ prices[tier][currency][term + 'Disc'].toFixed(0) }}
      </span>
      <span v-if="tier === 'basic'">
        FREE
      </span>
    </div>
    <div :class="$style.term + ' pt-1 text-muted'" v-if="tier != 'basic'">
        <span v-if="term === 'monthly'">/ MONTH</span>
        <span v-else>/ YEAR</span>
    </div>
    <div :class="$style.term + ' pt-1 text-muted'" v-else>
        <span>FOREVER</span>
    </div>
  </div>
</template>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<script>
export default {
  props: ['term', 'tier', 'currency', 'prices'],
  data: () => ({
  }),
}
</script>
